import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { DeptUserPicker } from "@/components/work/WorkParts";

export function DepartmentManagers({ departments }) {
  const [mgrs, setMgrs] = useState({});
  const [matrix, setMatrix] = useState([]);
  const load = () => {
    departments.forEach((d) => api.get(`/work/department-users?department=${encodeURIComponent(d.name)}`).then((r) => setMgrs((m) => ({ ...m, [d.name]: r.data.manager }))).catch(() => {}));
    api.get("/work/approval-matrix").then((r) => setMatrix(r.data)).catch(() => {});
  };
  useEffect(load, [departments]); // eslint-disable-line react-hooks/exhaustive-deps
  const setMgr = async (dept, uid) => {
    try { await api.put("/rbac/departments/manager", { department: dept, manager_id: uid || null }); toast.success(`${dept} manager updated`); load(); }
    catch (e) { toast.error(typeof e.response?.data?.detail === "string" ? e.response.data.detail : "Failed"); }
  };
  const setApprover = async (m, patch) => {
    try { const r = await api.put("/work/approval-matrix", { approval_type: m.approval_type, department: m.department, role: m.role, user_id: m.user_id || null, ...patch }); setMatrix(r.data); toast.success("Approval matrix saved"); }
    catch (e) { toast.error(typeof e.response?.data?.detail === "string" ? e.response.data.detail : "Failed"); }
  };
  return (
    <div className="grid lg:grid-cols-2 gap-4" data-testid="dept-managers">
      <div className="bg-card border border-border rounded-lg p-4 space-y-2">
        <p className="text-[10px] font-mono uppercase tracking-widest text-muted-foreground">Department managers — receive "assignee required" alerts & escalations</p>
        {departments.map((d) => (
          <div key={d.name} className="grid grid-cols-2 gap-2 items-center text-sm" data-testid={`dept-mgr-row-${d.code}`}>
            <span>{d.name}<span className="block text-xs text-muted-foreground">{mgrs[d.name]?.name ? `${mgrs[d.name].name} – ${mgrs[d.name].designation || ""}` : "No manager set"}</span></span>
            <DeptUserPicker department={d.name} value={mgrs[d.name]?.user_id || ""} onChange={(v) => setMgr(d.name, v)} testid={`dept-mgr-pick-${d.code}`} />
          </div>))}
      </div>
      <div className="bg-card border border-border rounded-lg p-4 space-y-2">
        <p className="text-[10px] font-mono uppercase tracking-widest text-muted-foreground">Approval matrix — who approves what (resolves to a specific person)</p>
        {matrix.map((m) => (
          <div key={m.approval_type} className="grid grid-cols-2 gap-2 items-center text-sm" data-testid={`matrix-row-${m.approval_type}`}>
            <span>{m.label}<span className="block text-xs text-muted-foreground">{m.department} · role {m.role} → <b className={m.resolved ? "text-signal-green" : "text-signal-red"}>{m.resolved ? `${m.resolved.name}` : "UNRESOLVED"}</b></span></span>
            <DeptUserPicker department={m.department} value={m.user_id || ""} onChange={(v) => setApprover(m, { user_id: v })} testid={`matrix-pick-${m.approval_type}`} />
          </div>))}
      </div>
    </div>
  );
}
